const AppTheme = {
    tableRowHeight: 32,
    tableHeaderHeight: 32,
    filterPageWidth: 220,
    zIndexes: {
        actionsDropdown: 1,
        globalSearch: 2
    }
}

export default AppTheme;